export const DIALOG_WIDTH = 310;

export const DIALOG_WIDTH_WIDER = 325;
